import React from "react";
import * as faqModule from "@/data/faqContent";

export default function Faq() {
  const items = faqModule.FAQ_ITEMS || [];
  const contact = faqModule.FAQ_CONTACT_EMAIL || "Info@ParanormalArchetypes.net";
  const updated = faqModule.FAQ_LAST_UPDATED;

  const flat = Array.isArray(items)
    ? items
    : [];

  return (
    <div className="space-y-6">
      <header>
        <h1 className="pa-serif text-3xl md:text-4xl" style={{ color: "var(--pa-text-primary)" }}>FAQ</h1>
        {updated && <p className="text-xs mt-1" style={{ color: "var(--pa-text-muted)" }}>Updated {updated}</p>}
      </header>
      <div className="space-y-3">
        {flat.map((entry, i) => {
          // Support either {question, answer} or category shape
          if (entry.items) {
            return (
              <div key={i} className="pa-card p-5">
                {entry.title && <h2 className="pa-serif text-lg mb-3" style={{ color: "var(--pa-gold)" }}>{entry.title}</h2>}
                {(entry.items || []).map((q, j) => (
                  <div key={j} className="mb-3">
                    <p className="pa-serif text-sm" style={{ color: "var(--pa-text-primary)" }}>{q.question}</p>
                    <p className="text-sm mt-1 whitespace-pre-line" style={{ color: "var(--pa-text-secondary)" }}>{q.answer}</p>
                  </div>
                ))}
              </div>
            );
          }
          return (
            <div key={i} className="pa-card p-5">
              <p className="pa-serif text-base" style={{ color: "var(--pa-text-primary)" }}>{entry.question || entry.q}</p>
              <p className="text-sm mt-1 whitespace-pre-line" style={{ color: "var(--pa-text-secondary)" }}>{entry.answer || entry.a}</p>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-center" style={{ color: "var(--pa-text-muted)" }}>Questions? Email <a href={`mailto:${contact}`} style={{ color: "var(--pa-gold)" }}>{contact}</a></p>
    </div>
  );
}
